export function circleToPolygon({ lat, lng }: { lat: number; lng: number }, radius: number) {
  const earthRadius = 6371

  const latRad = lat * (Math.PI / 180)
  const lngRad = lng * (Math.PI / 180)
  const radiusRad = radius / earthRadius

  const minLat = latRad - radiusRad
  const maxLat = latRad + radiusRad
  const minLng = lngRad - Math.asin(Math.sin(radiusRad) / Math.cos(latRad))
  const maxLng = lngRad + Math.asin(Math.sin(radiusRad) / Math.cos(latRad))

  const minLatDeg = minLat * (180 / Math.PI)
  const maxLatDeg = maxLat * (180 / Math.PI)
  const minLngDeg = minLng * (180 / Math.PI)
  const maxLngDeg = maxLng * (180 / Math.PI)

  const coordinates = [
    [
      [minLngDeg, minLatDeg], // bottom-left corner
      [maxLngDeg, minLatDeg], // bottom-right corner
      [maxLngDeg, maxLatDeg], // top-right corner
      [minLngDeg, maxLatDeg], // top-left corner
      [minLngDeg, minLatDeg], // closing the polygon
    ],
  ]

  return {
    type: 'Polygon' as const,
    coordinates: coordinates,
  }
}
